import styled from 'styled-components';

export const StyledMiddleEllipsisWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const StyledMiddleEllipsisParent = styled.div`
  word-break: keep-all;
  overflow-wrap: normal;
`;

export const StyledMiddleEllipsisText = styled.span`
  word-break: keep-all;
  overflow-wrap: normal;
  white-space: nowrap;
`;
